import { cn } from "@/lib/utils"
import { primaryButtonClass } from "../lightTheme"
import { finalConverterContent } from "./finalConverterContent"

const longButtonClass = cn(
  primaryButtonClass,
  "h-auto min-h-10 max-w-full whitespace-normal px-4 py-2 text-left"
)

export default function FinalConverterSection() {
  return (
    <section className="flex w-full translate-x-[calc(50vw-50%-1.5rem)] flex-col items-start gap-8">
      <h2 className="text-balance text-[48px] font-bold leading-[56px] tracking-[-0.04em] text-[#171717] max-md:text-[32px] max-md:leading-10">
        {finalConverterContent.title}
      </h2>
      <p className="max-w-[68ch] text-[18px] font-normal leading-7 text-[#4D4D4D]">
        {finalConverterContent.body}
      </p>
      <button type="button" className={longButtonClass}>
        {finalConverterContent.cta}
      </button>
      <p className="text-[14px] font-normal leading-5 text-[#4D4D4D]">
        {finalConverterContent.note}
      </p>
    </section>
  )
}
